export const QUICK_ALGOLIA_SEARCH_QUERY = "QUICK_ALGOLIA_SEARCH_QUERY";

export const setAlgoliaSearchQuery = algoliaQuery => ({
  type: QUICK_ALGOLIA_SEARCH_QUERY,
  payload: {
    algoliaQuery,
  }
});